// extracted by mini-css-extract-plugin
export var black = "_11-6";
export var brand = "_11-1";
export var ddefault = "_11-0";
export var error = "_11-3";
export var gray = "_11-2";
export var highContrast = "_11-8";
export var outline = "_11-7";
export var success = "_11-5";
export var warning = "_11-4";